import App from '../../../vendor_core/core/src/App';
import { Tween } from '../../../vendor_core/core/src/Tween';
import { Commands } from '../../../vendor_core/core/src/commands/CommandEnum';
import CommandManager from '../../../vendor_core/core/src/commands/CommandManager';
import GameEvents from '../../../vendor_core/core/src/const/GameEvents';
import GameModel from '../../../vendor_core/core/src/model/GameModel';
import SpinModel from '../../../vendor_core/core/src/model/SpinModel';
import ReelGroup from '../../../vendor_core/core/src/views/ReelGroup';
import VendorSpinEndState from '../../../vendor_core/src/states/VendorSpinEndState'
import CoinModel from '../../model/CoinModel';

export default class CRSpinEndState extends VendorSpinEndState {
    protected showCoinTime = 200;
    // Here need to check for coins
    protected onResponse(): void {
        App.dispatcher.emit(GameEvents.SPIN_COMPLETE);
        if (SpinModel.isInFreespins()) {
            CommandManager.execute(
                Commands.UPDATE_FREE_SPINS,
                SpinModel.freespinsNum.toString()
            )
        }

        // let coins = CoinModel.showCurrentCoins();

        const delay = GameModel.turboSpin ? 0.3 : this.showCoinTime / 1000;

        // const delay = (coins * this.showCoinTime) / 1000;
        Tween.delayedCall(delay , () => {
            this.exit();
        })
    }
};
